/**
 * searchTabs - Alternância entre abas Hotel e Pacote na busca.
 * Sincroniza estado entre desktop e mobile.
 * Expõe getActiveTab(form) e isPackageActive() para outros módulos.
 * Dispara CustomEvent 'searchtab:change' em troca de aba e no init (estado inicial).
 */
kombi.searchTabs = function () {
    const TAB = {
        HOTEL: 'hotel',
        PACKAGE: 'package'
    };

    const SELECTORS = {
        TAB_BUTTON: '[data-search-tab]',
        HOTEL_FIELDS: '.search-hotel-fields',
        PACKAGE_FIELDS: '.search-package-fields',
        SEARCH_SUBMIT_BTN: '[data-search-submit-btn]'
    };

    const CLASS = {
        HOTEL_ACTIVE: 'btn-primary',
        HOTEL_INACTIVE: 'btn-outline-primary bg-white border',
        PACKAGE_ACTIVE: 'btn-tab-package-active',
        PACKAGE_INACTIVE: 'btn-tab-package bg-white border text-package',
        HIDDEN: 'd-none'
    };

    let activeTab = TAB.HOTEL;

    function getAllTabButtons() {
        return document.querySelectorAll(SELECTORS.TAB_BUTTON);
    }

    function getTabValue(btn) {
        return btn.getAttribute('data-search-tab') || '';
    }

    function setActiveTab(value) {
        activeTab = value;
    }

    function updateButtonStyles() {
        getAllTabButtons().forEach(function (btn) {
            const tabValue = getTabValue(btn);
            const isActive = tabValue === activeTab;

            btn.classList.remove('btn-primary', 'btn-outline-primary', 'btn-tab-package', 'btn-tab-package-active', 'bg-white', 'border', 'text-primary-emphasis', 'text-package');

            if (tabValue === TAB.HOTEL) {
                btn.classList.add(...(isActive ? [CLASS.HOTEL_ACTIVE] : CLASS.HOTEL_INACTIVE.split(' ')));
            } else if (tabValue === TAB.PACKAGE) {
                if (isActive) {
                    btn.classList.add(CLASS.PACKAGE_ACTIVE, 'btn-tab-package');
                } else {
                    btn.classList.add(...CLASS.PACKAGE_INACTIVE.split(' '));
                }
            }
        });
    }

    function updateFieldsVisibility() {
        const hotelFields = document.querySelectorAll(SELECTORS.HOTEL_FIELDS);
        const packageFields = document.querySelectorAll(SELECTORS.PACKAGE_FIELDS);

        hotelFields.forEach(function (el) {
            el.classList.toggle(CLASS.HIDDEN, activeTab !== TAB.HOTEL);
        });

        packageFields.forEach(function (el) {
            el.classList.toggle(CLASS.HIDDEN, activeTab !== TAB.PACKAGE);
        });
    }

    /** Disable inputs in the inactive tab so duplicate names (e.g. location) are not submitted. */
    function syncTabInputsDisabled() {
        const controlSelector = 'input, select, textarea';
        document.querySelectorAll('.SearchForm').forEach(function (form) {
            const hotelControls = form.querySelectorAll(
                `${SELECTORS.HOTEL_FIELDS} ${controlSelector}`
            );
            const packageControls = form.querySelectorAll(
                `${SELECTORS.PACKAGE_FIELDS} ${controlSelector}`
            );

            const hotelActive = activeTab === TAB.HOTEL;
            hotelControls.forEach(function (el) {
                el.disabled = !hotelActive;
            });
            packageControls.forEach(function (el) {
                el.disabled = hotelActive;
            });
        });
    }

    function updateSearchButtonStyles() {
        document.querySelectorAll(SELECTORS.SEARCH_SUBMIT_BTN).forEach(function (btn) {
            btn.classList.toggle('btn-search-package', activeTab === TAB.PACKAGE);
        });
    }

    /**
     * Package vs hotel theme: toggles body + form classes for SCSS (hover, flatpickr, counters).
     * Flatpickr renders to the body, so the class must be on the document.
     */
    function updateSearchTabThemeClass() {
        const isPackage = activeTab === TAB.PACKAGE;
        document.body.classList.toggle('search-tab-package-active', isPackage);
        document.querySelectorAll('.SearchForm').forEach(function (form) {
            form.classList.toggle('search-form--package', isPackage);
        });
    }

    function dispatchSearchTabChange() {
        document.dispatchEvent(
            new CustomEvent('searchtab:change', {
                detail: {
                    activeTab: activeTab,
                    isPackage: activeTab === TAB.PACKAGE
                }
            })
        );
    }

    function switchTo(tabValue) {
        if (tabValue !== TAB.HOTEL && tabValue !== TAB.PACKAGE) return;

        setActiveTab(tabValue);
        updateButtonStyles();
        updateFieldsVisibility();
        syncTabInputsDisabled();
        updateSearchButtonStyles();
        updateSearchTabThemeClass();
        dispatchSearchTabChange();
    }

    function setupTabClickHandlers() {
        getAllTabButtons().forEach(function (btn) {
            btn.addEventListener('click', function () {
                const tabValue = getTabValue(btn);
                switchTo(tabValue);
            });
        });
    }

    /**
     * Prefer the Package tab button state inside this form when tabs are rendered
     * together with the form (desktop). Fallback to the shared active tab for
     * contexts where the tab buttons live outside the form (mobile modal).
     */
    function getActiveTab(form) {
        const packageBtn = form.querySelector('[data-search-tab="package"]');
        if (packageBtn) {
            return packageBtn.classList.contains(CLASS.PACKAGE_ACTIVE)
                ? TAB.PACKAGE
                : TAB.HOTEL;
        }
        return activeTab;
    }

    function isPackageActive() {
        return activeTab === TAB.PACKAGE;
    }

    kombi.searchTabs.getActiveTab = getActiveTab;
    kombi.searchTabs.syncTabInputsDisabled = syncTabInputsDisabled;
    kombi.searchTabs.isPackageActive = isPackageActive;

    function init() {
        activeTab = TAB.HOTEL;
        document.querySelectorAll('.search-tabs-container').forEach(function (container) {
            if (container.getAttribute('data-initial-tab') === TAB.PACKAGE) {
                activeTab = TAB.PACKAGE;
            }
        });

        setupTabClickHandlers();
        updateButtonStyles();
        updateFieldsVisibility();
        syncTabInputsDisabled();
        updateSearchButtonStyles();
        updateSearchTabThemeClass();
        dispatchSearchTabChange();
    }

    return init();
};
